/**
 * Created by stonewang on 2017/8/15.
 */
import React from 'react';


class Region extends React.Component {
	render() {
		
		return (
			<div>
				{this.props.children}
			</div>
		)
	}
}
;
export default Region;


// WEBPACK FOOTER //
// ./src/routes/region/index.js